export default class ListToggler {
  constructor () {
    this.bar = document.querySelector('.list-toggle-bar')
    this.targetTiles = this.bar ? document.querySelector(`#${this.bar.dataset.target}`) : null

    if (!this.bar || !this.targetTiles) {
      return
    }

    const pageID = document.body.dataset.pageId || 'global'
    this.lookupKey = `page-${pageID}-tile-viewMode`

    this.barTogglers = this.bar.querySelectorAll('.list-toggle-bar__button')
    this.savedStates = localStorage && localStorage.savedTileStates
      ? JSON.parse(localStorage.savedTileStates)
      : {}

    this.init()
    this.applySavedStates()
  }

  init () {
    this.barTogglers.forEach(toggler => {
      toggler.addEventListener('click', this.clickHandler.bind(this))
    })
  }

  applySavedStates () {
    if (this.savedStates[this.lookupKey] && this.savedStates[this.lookupKey] == 'list') {
      Array.from(this.barTogglers).find(toggler => toggler.dataset.view == 'list').dispatchEvent(new Event('click'))
    }
  }

  clickHandler (e) {
    e.preventDefault()
    const btn = e.currentTarget
    if (btn.classList.contains('active')) {
      return
    }

    const viewMode = btn.dataset.view
    this.clearCurrentState()
    btn.classList.add('active')
    this.savedStates[this.lookupKey] = viewMode

    if (viewMode == 'list') {
      this.targetTiles.classList.add('list-view')
    } else {
      this.targetTiles.classList.remove('list-view')
    }

    localStorage.setItem('savedTileStates', JSON.stringify(this.savedStates))
  }

  clearCurrentState () {
    this.barTogglers.forEach(toggler => {
      toggler.classList.remove('active')
    })
  }
}
